import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

const MarkingRuleForm = ({ rule = null }) => {
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: rule || {}
  });

  const onSubmit = async (data) => {
    try {
      const response = await fetch(
        rule ? `/api/marking-rules/${rule._id}` : '/api/marking-rules',
        {
          method: rule ? 'PATCH' : 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify(data)
        }
      );

      if (!response.ok) throw new Error('Failed to save marking rule');
      
      navigate('/admin/marking-rules');
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-6">{rule ? 'Edit' : 'Create'} Marking Rule</h2>
      
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Title</label>
          <input
            {...register('title', { required: true })}
            type="text"
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          />
          {errors.title && <p className="text-red-500 text-sm">Title is required</p>}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Exam Type</label>
          <select
            {...register('examType', { required: true })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
          >
            <option value="ssc">SSC</option>
            <option value="bank">Bank</option>
            <option value="railway">Railway</option>
            <option value="other">Other</option>
          </select>
          {errors.examType && <p className="text-red-500 text-sm">Exam Type is required</p>}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Included Letters</label>
          <textarea
            {...register('includedLetters', { required: true })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            placeholder="Enter letters separated by commas"
          />
          {errors.includedLetters && <p className="text-red-500 text-sm">Included letters are required</p>}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Excluded Letters</label>
          <textarea
            {...register('excludedLetters', { required: true })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            placeholder="Enter letters separated by commas"
          />
          {errors.excludedLetters && <p className="text-red-500 text-sm">Excluded letters are required</p>}
        </div>

        <div>
          <h3 className="text-lg font-medium mb-4">Marking Scheme</h3>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Correct Word</label>
              <input
                {...register('markingScheme.correctWord', { required: true })}
                type="number"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Wrong Word</label>
              <input
                {...register('markingScheme.wrongWord', { required: true })}
                type="number"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Time Penalty</label>
              <input
                {...register('markingScheme.timePenalty')}
                type="number"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              />
            </div>
          </div>
        </div>

        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={() => navigate('/admin/marking-rules')}
            className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            {rule ? 'Update' : 'Create'} Rule
          </button>
        </div>
      </form>
    </div>
  );
};

export default MarkingRuleForm;
